<template>
  <ui-row>
    <ui-col>
      <ui-heading tag="h3" class="heading-bullet" margin>{{
        $t("pageNotFound")
      }}</ui-heading>
      <ui-heading tag="h4" margin>{{ $t("pageNotFoundDesp") }}</ui-heading>
      <ui-button @click.native="$router.push('/index')">{{
        $t("backToHome")
      }}</ui-button>
    </ui-col>
  </ui-row>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
